module.exports = __webpack_public_path__ + "img/20190817131539QQ截图20190817124053.9354091e.png";